import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callOfaPayApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';

const extraInput=["Alipay2alipay", "P2P", "P2P_Manual","DinTalk", "ECNY","QRIS","VABCA","OFA_UPI","VA","Duitnow","Zalo","QRIS","VABCA","OB","Duitnow"]

const OfaPay = (props) => {
    const { translate, lang } = useLanguage();
    const [loadingOfaPayInfo, setLoadingOfapayInfo] = useState(false);
    const [infoOfapay, setInfoOfaPay] = useState(sessionStorage.getItem("ofapay_info") !== null ? JSON.parse(sessionStorage.getItem("ofapay_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [accountName, setAccountName] = useState("");
    const [bankNo, setBankNo] = useState("");
    const [loading, setLoading] = useState(true);
    const [country, setCountry] = useState(sessionStorage.getItem("country").toLocaleUpperCase());

    useEffect(() => {
        translate();
    }, [translate]);

    const handleAccountNameChange = (e) => {
        setAccountName(e.target.value);
    };

    const handleBankNoChange = (e) => {
        setBankNo(e.target.value);
    };

    const callOfapay = () => {
        setLoadingOfapayInfo(true);
        if (infoOfapay[props.payment_type] === undefined) {
            callOfaPayApi(sessionStorage.getItem("order_no"), props.payment_type, accountName, bankNo)
                .then(res => {
                    if (res.status!== "-1") {
                        setInfoOfaPay({ ...infoOfapay, [props.payment_type]: res });
                        sessionStorage.setItem("ofapay_info", JSON.stringify({ ...infoOfapay, [props.payment_type]: res }));
                        setLoadingOfapayInfo(false);
                    } else {
                        setErrorMsg(res?.respmsg || "Please, talk with the Administrator.");
                        setLoadingOfapayInfo(false);
                        setIsError(true);
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error");
                    setIsError(true);
                }).finally(() => {
                    setLoadingOfapayInfo(false);
                    translate();
                });
        }
    };

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    });
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingOfaPayInfo]);

    useEffect(() => {
        if (infoOfapay[props.payment_type] === undefined && !extraInput.includes(props?.payment_type)) {
            callOfapay();
        }
        return () => {
            const iframe = document.getElementById('ofapay_frame');
            if (iframe) {
                iframe.removeEventListener('load', () => { });
            }
        };
    }, []);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href = redirectedUrl;
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);



    const callApi = (e) => {
        e.preventDefault();
        callOfapay();
    };

    const getBankOptions = () => {
        if (["QRIS", "VABCA", "OB"].includes(props.payment_type) && country === "ID") {
            return [
                { "bankno": "BCA", "bank_name": "Bank Central Asia" },
                { "bankno": "BDM", "bank_name": "Bank Danamon" },
                { "bankno": "BNI", "bank_name": "Bank Negara Indonesia" },
                { "bankno": "BRI", "bank_name": "Bank Rakyat Indonesia" },
                { "bankno": "CIMB", "bank_name": "CIMB" },
                { "bankno": "MDR", "bank_name": "Bank Mandiri" },
                { "bankno": "PRMT", "bank_name": "Bank Permata" }
            ];
        } else if (["Duitnow"].includes(props.payment_type) && country === "MY") {
            return [
                { "bank_name": "Affin Bank Berhad", "bankno": "14911" },
                { "bank_name": "Affin Islamic Bank Berhad", "bankno": "14912" },
                { "bank_name": "Alliance Bank Malaysia Berhad", "bankno": "14913" },
                { "bank_name": "Alliance Islamic Bank Malaysia Berhad", "bankno": "14914" },
                { "bank_name": "Al Rajhi Banking & Investment Corporation (Malaysia) Berhad", "bankno": "14915" },
                { "bank_name": "AmBank (M) Berhad", "bankno": "14916" },
                { "bank_name": "Bank Islam Malaysia Berhad", "bankno": "14917" },
                { "bank_name": "Bank Kerjasama Rakyat Malaysia Berhad", "bankno": "14918" },
                { "bank_name": "Bank Muamalat Malaysia Berhad", "bankno": "14919" },
                { "bank_name": "Bank of China (Malaysia) Berhad", "bankno": "14920" },
                { "bank_name": "Bank Pertanian Malaysia Berhad (Agrobank)", "bankno": "14921" },
                { "bank_name": "Bank SimpananNasional", "bankno": "14922" },
                { "bank_name": "CIMB Bank Berhad", "bankno": "14923" },
                { "bank_name": "CIMB Islamic Bank Berhad", "bankno": "14924" },
                { "bank_name": "Citibank Berhad", "bankno": "14925" },
                { "bank_name": "Hong Leong Bank Berhad", "bankno": "14926" },
                { "bank_name": "Hong Leong Islamic Bank Berhad", "bankno": "14927" },
                { "bank_name": "HSBC Amanah Malaysia Berhad", "bankno": "14928" },
                { "bank_name": "HSBC Bank Malaysia Berhad", "bankno": "14929" },
                { "bank_name": "Industrial and Commercial Bank of China (Malaysia) Berhad", "bankno": "14930" },
                { "bank_name": "Kuwait Finance House", "bankno": "14931" },
                { "bank_name": "Malayan Banking Berhad", "bankno": "14932" },
                { "bank_name": "MBSB Bank Berhad", "bankno": "14933" },
                { "bank_name": "OCBC Bank (Malaysia) Berhad", "bankno": "14934" },
                { "bank_name": "Public Bank Berhad", "bankno": "14935" },
                { "bank_name": "RHB Bank Berhad", "bankno": "14936" },
                { "bank_name": "RHB Islamic Bank Berhad", "bankno": "14937" },
                { "bank_name": "Standard Chartered Bank Malaysia Berhad", "bankno": "14938" },
                { "bank_name": "Standard Chartered Saadiq Berhad", "bankno": "14939" },
                { "bank_name": "United Overseas Bank (Malaysia) Berhad", "bankno": "14940" }
              ]
              
        } else if (["OB"].includes(props.payment_type) && country === "PH") {
            return [
                { "bankno": "605", "bank_name": "Landbank - TLBPP" },
                { "bankno": "604", "bank_name": "Metropolitan Bank and Trust Co - MBT" }
            ];
        }
        return [];
    };

    return (
        <>
            {loadingOfaPayInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {!loadingOfaPayInfo && infoOfapay[props.payment_type] === undefined  && isError===false &&(
                <div className='col-md-12 d-flex justify-content-center mt-5'>
                    <form style={{ minWidth: "100%" }} onSubmit={callApi}>
                        {(props.payment_type === "Alipay2alipay" || props.payment_type === "P2P" || props.payment_type === "P2P_Manual" || props.payment_type === "DinTalk" || props.payment_type === "ECNY" || props.payment_type === "QRIS" || props.payment_type === "VABCA" || props.payment_type === "OB" || props.payment_type === "OFA_UPI" || props.payment_type === "VA" || props.payment_type === "Duitnow" || props.payment_type === "Zalo") && (
                            <div className='form-group'>
                                <label htmlFor="account_name">{getStrLang(lang.nameLang, "account_name")}</label>
                                <input type="text" className='form-control' id="account_name" name="account_name" value={accountName} onChange={handleAccountNameChange} required />
                            </div>
                        )}
                        {getBankOptions().length > 0 && (
                            <div className='form-group'>
                                <label htmlFor="bank_no">{getStrLang(lang.nameLang, "bank_no")}</label>
                                <select className='form-control' id="bank_no" name="bank_no" value={bankNo} onChange={handleBankNoChange} required>
                                    <option value="" disabled>{getStrLang(lang.nameLang, "select_bank")}</option>
                                    {getBankOptions().map((bank) => (
                                        <option key={bank.bankno} value={bank.bankno}>{bank["bank_name"]}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                    </form>
                </div>
            )}

            <div className=''>
                {infoOfapay[props.payment_type] !== undefined ? (
                    <>
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                            </div>
                            <iframe
                                id='ofapay_frame'
                                src={`${infoOfapay[props.payment_type]['url']}`}
                                title={`${props.payment_type}`}
                                width="100%"
                                height="800px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    </>
                ) : (
                    <>
                    </>
                )}

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{errorMsg}</h4>
                </div>}
            </div>
        </>
    );
}

export default OfaPay;
